import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SessionService } from '@core';

import { TravelTimeImprovementsResult } from '../../models/travel-time-improvements-result.model';
import { TravelTimeImprovementResult } from '../../models/travel-time-improvement-result.model';
import { SuggestionInformation } from '../../models/suggestion-information.model';
import { HandleTravelTimeImprovementResult } from '../../models/handle-travel-time-tmprovement-result.model';

@Injectable({
    providedIn: 'root'
})
export class TravelTimeImprovementService {
    private readonly httpClient = inject(HttpClient);
    private readonly sessionService = inject(SessionService);


    public getTravelTimeImprovements(): Observable<TravelTimeImprovementsResult> {
        const url = `${this.sessionService.getApiUrl()}/traveltime_improvements/${this.sessionService.getJobId()}/5`;
        return this.httpClient.post<TravelTimeImprovementsResult>(url, {});
    }

    public getTravelTimeImprovement(improvementId: string): Observable<TravelTimeImprovementResult> {
        const url = `${this.sessionService.getApiUrl()}/traveltime_improvement/${this.sessionService.getJobId()}/${improvementId}`;
        return this.httpClient.get<TravelTimeImprovementResult>(url);
    }

    public handleTravelTimeImprovement(
        improvementId: string,
        suggestionInformationList: SuggestionInformation[]
    ): Observable<HandleTravelTimeImprovementResult> {
        const url = `${this.sessionService.getApiUrl()}/handle_traveltime_improvement_action_v2/${
            this.sessionService.requestId
        }/${this.sessionService.getJobId()}/${improvementId}`;
        const body = {
            improvementId,
            suggestionInformationList: JSON.parse(JSON.stringify(suggestionInformationList))
        };

        return this.httpClient.put<HandleTravelTimeImprovementResult>(url, body);
    }
}
